<div class="container">
    <div class="row text-center justify-content-center">
        <div class="col-lg-9">
            <div class="tagline mt-accent-text mb-2">Pricing for membership organizations</div>
            <h1 class="headline mt-primary-text mb-2">Simple pricing. Powerful membership management.</h1>
            <p class="subheadline mt-primary-text mb-3">
                Choose the platform that fits how your organization operates, then add the level of support you want.
                Pay for active members—not every historical contact—with $1 per month for each active member above your included allotment, billed monthly.
            </p>
        </div>
    </div>
</div>
